import { render } from "./InfoMessageAlerts.vue?vue&type=template&id=1767e5f2"
import script from "./InfoMessageAlerts.vue?vue&type=script&lang=js"
export * from "./InfoMessageAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__